import { FlatStrapi, StrapiData, StrapiResponse } from './strapi-response';

export class StrapiFactory {
  static responseToView<T extends object, K extends string>(
    response: StrapiResponse<T, K>,
    key: K
  ) {
    return response.data[key].data.attributes;
  }

  static flatInnerObjects<
    K extends keyof D,
    D extends StrapiData<T, K>,
    T extends object = D[K]['data']['attributes']
  >(obj: D | undefined, keys: K[]): FlatStrapi<K, D, T> {
    let flatObj: FlatStrapi<K, D, T> = {} as FlatStrapi<K, D>;
    keys.forEach((key) => {
      try {
        let attributes = obj?.[key].data?.attributes;
        delete obj?.[key];
        flatObj[key] = attributes as FlatStrapi<K, D, T>[K];
      } catch (e) {
        console.error(e);
      }
    });

    return { ...flatObj, ...obj };
  }

  static flatStuff<
    K extends keyof D,
    D extends StrapiData<T, K>,
    C extends keyof O,
    O extends Record<C, D | D[]>,
    T extends object = D[K]['data']['attributes']
  >(obj: O, [key, iK]: [C, K[]]): O {
    //keyPairs.forEach(([key, iK]) => {
    let innerObj = obj[key];
    if (Array.isArray(innerObj)) {
      obj[key] = innerObj.map((item) => {
        return this.flatInnerObjects<K, D, T>(item, iK);
      }) as any;
    } else {
      obj[key] = this.flatInnerObjects<K, D, T>(innerObj as D, iK) as any;
    }
    //});
    return obj;
  }
}

//export type F<T extends Record<C, Record<K, any> | Record<K, any>[]>, C extends keyof T, K extends keyof T[C] | keyof T[C][0]> = [C, K[]];
